export const NavItemsUser: { name; router; icon; isItFillIcon }[] = [
  {
    name: 'home',
    router: '',
    icon: 'home',
    isItFillIcon: false,
  },
  {
    name: 'booking',
    router: `/app/reserve/booking`,
    icon: 'calendar_month',
    isItFillIcon: false,
  },
  {
    name: 'reports',
    router: `/app/reports`,
    icon: 'assignment',
    isItFillIcon: false,
  },
  {
    name: 'articles',
    router: `/app/blogs`,
    icon: 'breaking_news',
    isItFillIcon: false,
  },
];
 